import { Box, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import AddIcon from "@mui/icons-material/Add";
import CustomButton from "./CustomShapedBtn";

// import { CustomButton } from "../../../components";
const TicketHeader = ({ onClickAddNew }) => {
  const { palette, ...theme } = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <Typography
        sx={{
          textTransform: "capitalize",
          fontFamily: "var(--font-mz_r)",
          alignItems: "center",
          color: palette.grey[200],
          fontSize: {
            xl: "2vw",
            lg: "2vw",
            md: "40px",
            sm: "40px",
            xs: "40px",
          },
        }}
      >
        Support Tickets
      </Typography>
      <CustomButton
        variant="primary"
        title="New Ticket"
        onClick={onClickAddNew}
        icon={<AddIcon />}
      />
    </Box>
  );
};

export default TicketHeader;
